<template>
<div class="chapter">
<div class="inner_page">
<p class="toctitle"><a id="page_v">Contents</a></p><a id="page_v">
</a><p class="tocb"><a id="page_v"></a><a href="#/xhtml/07_Fm02">·  <i>Note about Translation and Transliteration</i></a></p>
<p class="tocb"><a href="#/xhtml/08_Fm03">·  <i>Note on Previously Published Material</i></a></p>
<p class="tocbb"><a href="#/xhtml/09_Acknowledgement">·  <i>Acknowledgments</i></a></p>
<p class="toca"><a href="#/xhtml/11_Introduction">Introduction</a></p>
<p class="toc"><a href="#/xhtml/12_Chapter01">1  Burying the Dead: Cemeteries, Walls, and Jewish Identity in Early Twentieth-Century Argentina</a></p>
<p class="toc"><span href="#/xhtml/13_Chapter02" title="Link target outside of Sample">2  Helping the Living: Philanthropy and the Boundaries of Sephardi Communities in Argentina</span></p>
<p class="toc"><span href="#/xhtml/14_Chapter03" title="Link target outside of Sample">3  The Limits of Community: Unsuccessful Attempts at Creating Single Sephardi Organizations</span></p>
<p class="toc"><span href="#/xhtml/15_Chapter04" title="Link target outside of Sample">4  Working for the Homeland: Zionism and the Creation of an “Argentine” Sephardi Community after 1920</span></p>
<p class="toc"><span href="#/xhtml/16_Chapter05" title="Link target outside of Sample">5  Becoming Argentine, Becoming Jewish, Becoming and Remaining Sephardi: Jewish Women and Identity in Twentieth-Century Argentina</span></p>
<p class="toc1"><a id="page_vi"></a><span href="#/xhtml/17_Chapter06" title="Link target outside of Sample">6  Marriages and Schools: Living within Multiple Borders</span></p>
<p class="tocb"><span href="#/xhtml/18_Postscript" title="Link target outside of Sample">·  <i>Postscript</i></span></p>
<p class="tocb"><span href="#/xhtml/19_Notes" title="Link target outside of Sample">·  <i>Notes</i></span></p>
<p class="tocb"><span href="#/xhtml/20_Bibliography" title="Link target outside of Sample">·  <i>Bibliography</i></span></p>
<p class="tocb"><span href="#/xhtml/21_Index01" title="Link target outside of Sample">·  <i>Index</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?6da0b5e8